import React, { ChangeEvent, ReactNode } from 'react';
import * as S from './Radio.styled';

export type Direction = 'row' | 'column';

export interface RadioGroupProps {
  children: ReactNode;
  direction?: Direction;
  onChange: (e: ChangeEvent<HTMLFormElement>) => void;
}

const RadioGroup = React.forwardRef<HTMLFormElement, RadioGroupProps>(
  ({ children, direction = 'row', onChange }, forwardedRef) => {
    return (
      <form ref={forwardedRef} onChange={onChange}>
        <S.OptionWrapper direction={direction}>{children}</S.OptionWrapper>
      </form>
    );
  },
);

export default RadioGroup;
